import { Box, Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';

import { ListItemComp } from 'uiToolkitV1/ListItemComp';
import { Radio } from 'uiToolkitV1/Radio';

const StyledListItem = styled(ListItemComp)`
  border-radius: 0;
  color: ${(props) => props.theme.colors.text.g1};
`;

export const ListRadio = ({
  checked,
  onClick,
  label,
  rightContentComp = null,
  subText = '',
  disabled = false,
  value = '',
  icon = null,
  ...props
}) => {
  const RadioComponent = () => <Radio isChecked={checked} isDisabled={disabled} value={value} />;
  return (
    <Flex
      cursor={disabled ? 'not-allowed' : 'pointer'}
      justifyContent="space-between"
      alignItems="center"
      onClick={onClick}
    >
      <StyledListItem
        title={label}
        subTitle={subText}
        isDisabled={disabled}
        RightComponent={icon}
        LeftComponent={RadioComponent}
        isBoldText={false}
        active={checked}
        withoutBackground
        padding="16px 12px"
        {...props}
      />
      {rightContentComp && <Box mr={3}>{rightContentComp()}</Box>}
    </Flex>
  );
};
